<!-- CategoryRating.vue - one community rating criterion (e.g. Creativity) -->
<template>
  <section class="category-rating fade-in" :aria-labelledby="`${uid}-h`">
    <h3 :id="`${uid}-h`">{{ label || category }}</h3>
    <p v-if="description" :id="`${uid}-d`">{{ description }}</p>
    <StarRating
      :uniqueID="`${category.toLowerCase()}-${id}`"
      :label="label || category"
      :describedby="description ? `${uid}-d` : ''"
      :showStatus="true"
    />
  </section>
</template>

<script>
import StarRating from './StarRating.vue';

export default {
  name: 'CategoryRating',
  components: { StarRating },
  props: {
    category: { type: String, required: true }, // stable key, also used for storage
    label: { type: String, default: '' }, // translated name shown to people
    description: { type: String, required: false },
    id: { type: String, required: false },
  },
  computed: {
    uid() {
      return `cr-${this.category.toLowerCase().replace(/[^a-z0-9]/g, '')}-${this.id || ''}`;
    },
  },
};
</script>

<style scoped>
.category-rating { display: flex; flex-direction: column; align-items: flex-start; gap: 4px; padding: 16px; background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-lg); text-align: start; }
.category-rating h3, .category-rating p { margin: 0; }
.category-rating p { font-size: 14px; color: var(--color-secondary); }
</style>
